var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "3",
        height: "3",
        viewBox: "0 0 3 3",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2.90137 1.52148V1.53516C2.90137 2.31445 2.28613 2.92969 1.50684 2.92969H1.49316C0.713867 2.92969 0.0986328 2.31445 0.0986328 1.53516V1.52148C0.0986328 0.742188 0.713867 0.126953 1.49316 0.126953H1.50684C2.28613 0.126953 2.90137 0.742188 2.90137 1.52148Z",
          fill: "black",
          "fill-opacity": "0.45",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }